import React, { useEffect } from "react";
import { firePageReferredEvent, TrMetricsService } from "tr-web";

export function Metrics() {
  useFireTaskTemplateServicePageViewedEvent();
  useFirePageReferredEvent();
  return <></>;
}

function useFireTaskTemplateServicePageViewedEvent() {
  useEffect(() => {
    TrMetricsService.fire("task_template_service_page_viewed");
  }, []);
}

function useFirePageReferredEvent() {
  useEffect(() => {
    firePageReferredEvent();
  }, []);
}
